import { UserRepository } from "@api/repositories/UserRepository";

type Include = string[] | Record<string, string[]>;

export class UserProfileService {
    constructor(
        private readonly userRepository: UserRepository,
        private readonly include: Include
    ) {
    }

    getUserProfiles(userIds: (number | string)[]) {
        const query = {
            include: this.include,
            where: {
                userId: {
                    $in: userIds
                }
            },
            take: -1
        }

        return this.userRepository.profiles(query);
    }
}